import { render, staticRenderFns } from "./AudioSection.vue?vue&type=template&id=0b38e769&scoped=true"
import script from "./AudioSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AudioSection.vue?vue&type=style&index=0&id=0b38e769&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b38e769",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b38e769')) {
      api.createRecord('0b38e769', component.options)
    } else {
      api.reload('0b38e769', component.options)
    }
    module.hot.accept("./AudioSection.vue?vue&type=template&id=0b38e769&scoped=true", function () {
      api.rerender('0b38e769', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/editorSettingPanel/AudioSection.vue"
export default component.exports